import { ConversationMessageEntity } from '@marketplace-web/domain/conversation-messaging-data'
import { OfferMessage } from '@marketplace-web/domain/price-offers-data'

export function isOfferMessage(message: ConversationMessageEntity): message is OfferMessage {
  if (!message) return false

  return 'isCurrentOffer' in message
}
